import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DataContext } from "../../context/Data.context";
import { Loading, Separator } from "@moreirapontocom/npmhelpers";
import { useFormik } from "formik";

const CreateProfile = () => {
  const navigate: any = useNavigate();
  const { data, setData } = useContext(DataContext);

  useEffect(() => {
    setData({
      ...data,
      pageHeader: {
        title: "Create Profile",
        backButton: true,
        previousPage: "/listProfiles",
      },
    });
  }, []);

  const formCreateProfile: any = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      birth: "",
    },
    onSubmit: (values) => {
      formCreateProfile.setSubmitting(false);

      // Save profile to localStorage
      const storageKey = "profiles";
      const profilesStorage: any = localStorage.getItem(storageKey);
      let profiles: any = [];
      let isFirstProfile = true;
      if (profilesStorage) {
        profiles = JSON.parse(profilesStorage);
        if (profiles.length > 0) {
          isFirstProfile = false;
        }
      }
      profiles.push(values);
      localStorage.setItem(storageKey, JSON.stringify(profiles));

      // Redirect to pairReader
      navigate(isFirstProfile ? "/pairReader" : "/listProfiles");
      return;
    },
  });

  return <>
    <i className="fas fa-user-circle fa-4x"></i>

    <Separator size={20} />

    <form onSubmit={formCreateProfile.handleSubmit}>
      <div className="form-group mb-3">
        <input
          type="text"
          name="firstName"
          onChange={formCreateProfile.handleChange}
          value={formCreateProfile.values.firstName}
          className="form-control"
          id="firstName" />
        <label>First Name</label>
      </div>

      <div className="form-group mb-3">
        <input
          type="text"
          name="lastName"
          onChange={formCreateProfile.handleChange}
          value={formCreateProfile.values.lastName}
          className="form-control"
          id="lasName" />
        <label>Last Name</label>
      </div>

      <div className="row">
        <div className="col-2">
          <i className="fas fa-calendar-alt fa-2x"></i>
        </div>
        <div className="col">
          <div className="form-group mb-3">
            <input
              type="date"
              name="birth"
              onChange={formCreateProfile.handleChange}
              value={formCreateProfile.values.birth}
              className="form-control"
              id="birth" />
            <label>Date of Birth</label>
          </div>
        </div>
      </div>

      <Separator size={20} />

      <div className="d-grid">
        <button
          type="submit"
          disabled={formCreateProfile.isSubmitting}
          className="btn btn-primary btn-featured">
            <Loading loading={formCreateProfile.isSubmitting} parent="inline" color="text-white" />
            {!formCreateProfile.isSubmitting && <i className="fas fa-check me-2"></i>} Save Profile
        </button>
      </div>
    </form>
  </>
};

export default CreateProfile;